import React from 'react';

function About() {
  return (
    <div className="container">
      <article className="page">
        <h1>About Us</h1>
        <p className="updated">Who we are and why we built Construction Calculator.</p>

        <p>
          <strong>Construction Calculator</strong> is built to make life on
          the job site simpler. Whether you're an engineer estimating concrete,
          a contractor pricing a project, or a homeowner planning a renovation,
          our app gives you clear answers in seconds.
        </p>

        <h2>Our mission</h2>
        <p>
          To put fast, reliable construction tools in everyone's pocket — no
          spreadsheets, no guesswork, no internet required.
        </p>

        <h2>What you get</h2>
        <ul>
          <li>Accurate material estimators (cement, brick, tile, steel and more)</li>
          <li>Concrete, plaster, stairs, doors and roof calculators</li>
          <li>Ready-to-explore 3D apartment templates</li>
          <li>Curated interior &amp; exterior design galleries</li>
          <li>Shareable PDF reports for clients and teams</li>
        </ul>

        <h2>Built by builders, for builders</h2>
        <p>
          Construction Calculator is developed and maintained by a small team that understands
          what site work really looks like. We listen to feedback and ship
          updates regularly. If you have an idea or run into a bug, please
          reach out — we want to hear from you.
        </p>
      </article>
    </div>
  );
}

export default About;
